export default {
  strict: true,
  namespaced: true,
  state: {
    unread: 0
  },
  getters: {
    unread: (state, getters) => {
      return state.unread
    }
  },
  mutations: {
    reset: state => {
      state.unread = 0
    },
    update: (state, payload) => {
      state.unread = payload
    }
  }
}